/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateTriggerConditionRequestDto } from './CreateTriggerConditionRequestDto';
import {
    CreateTriggerConditionRequestDtoFromJSON,
    CreateTriggerConditionRequestDtoFromJSONTyped,
    CreateTriggerConditionRequestDtoToJSON,
    CreateTriggerConditionRequestDtoToJSONTyped,
} from './CreateTriggerConditionRequestDto';

/**
 * 
 * @export
 * @interface CreateTriggerRequestDto
 */
export interface CreateTriggerRequestDto {
    /**
     * How the next due date is computed after completion (TIME conditions only)
     * @type {string}
     * @memberof CreateTriggerRequestDto
     */
    basis: CreateTriggerRequestDtoBasisEnum;
    /**
     * 1–2 conditions: at most one TIME and one METER (composite = whichever fires first). Domain + DB unique(triggerId, conditionType) enforce this.
     * @type {Array<CreateTriggerConditionRequestDto>}
     * @memberof CreateTriggerRequestDto
     */
    conditions: Array<CreateTriggerConditionRequestDto>;
}


/**
 * @export
 */
export const CreateTriggerRequestDtoBasisEnum = {
    Floating: 'FLOATING',
    Fixed: 'FIXED'
} as const;
export type CreateTriggerRequestDtoBasisEnum = typeof CreateTriggerRequestDtoBasisEnum[keyof typeof CreateTriggerRequestDtoBasisEnum];


/**
 * Check if a given object implements the CreateTriggerRequestDto interface.
 */
export function instanceOfCreateTriggerRequestDto(value: object): value is CreateTriggerRequestDto {
    if (!('basis' in value) || value['basis'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    return true;
}

export function CreateTriggerRequestDtoFromJSON(json: any): CreateTriggerRequestDto {
    return CreateTriggerRequestDtoFromJSONTyped(json, false);
}

export function CreateTriggerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTriggerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'basis': json['basis'],
        'conditions': ((json['conditions'] as Array<any>).map(CreateTriggerConditionRequestDtoFromJSON)),
    };
}

export function CreateTriggerRequestDtoToJSON(json: any): CreateTriggerRequestDto {
    return CreateTriggerRequestDtoToJSONTyped(json, false);
}

export function CreateTriggerRequestDtoToJSONTyped(value?: CreateTriggerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'basis': value['basis'],
        'conditions': ((value['conditions'] as Array<any>).map(CreateTriggerConditionRequestDtoToJSON)),
    };
}

